import React, { useState } from 'react';
import { object, bool } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { CollectionActionType } from '../../../../../shared/types/collectionActionType';
import { EventTypes } from '../../../../../shared/utils/events/types';
import { copyCollection } from '../../../utils/api/collections';
import eventsReporter from '../../../../../shared/utils/events/reporter';
import raiseError from '../../../../../shared/utils/raiseError';
import { JS_JOIN_HOOK } from './constants';

const COPY_ROOT = 'collections_perseus.collection_page.header.actions';

const { actions } = EventTypes.collectionPage.header;

const CopyCollectionButton = ({ collection, isPersonal = true }) => {
    const [{ loading, success }, setState] = useState({
        loading: false,
        success: false,
    });

    const { userId } = getContext();
    const isLoggedIn = !!userId;

    const onCopyClick = async () => {
        const { id, name, description } = collection;

        reportCopyCollectionEvent('clicked');

        if (!isLoggedIn) {
            return;
        }

        try {
            setState({ loading: true, success: false });
            await copyCollection(id, name, description);

            reportCopyCollectionEvent('success');

            setState({ loading: false, success: true });
        } catch (err) {
            raiseError();

            reportCopyCollectionEvent('fail');

            setState({ loading: false, success: false });
        }
    };

    const reportCopyCollectionEvent = (eventName) => {
        const { id, name, ownerType } = collection;

        eventsReporter.report(actions.copyCollection[eventName], {
            actionName: CollectionActionType.COPY_COLLECTION,
            collection: {
                id,
                name,
                ownerType,
            },
        });
    };

    const getCopyListTitleKey = () => {
        const copyPrefix = success ? 'saved' : 'save';
        const listTypePrefix = isPersonal ? 'to_my_lists' : 'as_private_list';

        return `${COPY_ROOT}.${copyPrefix}_${listTypePrefix}`;
    };

    return (
        <Button
            fill={Button.FILLS.GHOST}
            color={Button.COLORS.GREY}
            loading={loading}
            disabled={success}
            onClick={onCopyClick}
            className={classNames('copy-collection-btn', { [JS_JOIN_HOOK]: !isLoggedIn })}
        >
            <I18n k={getCopyListTitleKey(isPersonal)} />
        </Button>
    );
};

CopyCollectionButton.propTypes = {
    collection: object,
    isPersonal: bool,
};

const mapStateToProps = ({ collection }) => ({ collection });

export { CopyCollectionButton };
export default connect(mapStateToProps)(CopyCollectionButton);
